import { getDay, getMonth, getYear, setMonth, format, getDate, addDays as fnsAddDays } from 'date-fns';
import it from 'date-fns/locale/it';
import { UserProfile } from '@/types';
import { Menu } from '@/models';

// Months in javascript dates start from ZERO
export const getMonthName = (month: number): string => {
    const date = setMonth(new Date(), month - 1);
    return format(date, 'MMMM', { locale: it });
};

export const addDays = (date: Date, days: number): Date => {
    if (!date) { return new Date(); }
    return fnsAddDays(date, days);
};

export const getCurrentDay = (): number => {
    return getDate(new Date());
};

export const getCurrentYear = (): number => {
    return getYear(new Date());
};

// Months in javascript dates start from ZERO
export const getCurrentMonth = (): number => {
    return getMonth(new Date()) + 1;
};

export const formatDate = (date: Date, dateFormat?: string): string => {

    if (!date) { return ''; }

    if (!dateFormat) { dateFormat = 'dd.MM.yyyy'; }

    if (!(date instanceof Date)) {
        date = new Date(date);
    }

    return format(date, dateFormat, { locale: it });
};

export const formatTime = (date: Date, timeFormat?: string): string => {

    if (!date) { return ''; }

    if (!timeFormat) { timeFormat = 'HH:mm'; }

    if (!(date instanceof Date)) {
        date = new Date(date);
    }

    return format(date, timeFormat, { locale: it });
};

export const formatDateTime = (date: Date, dateFormat?: string): string => {

   if (!date) { return ''; }

   if (!dateFormat) { dateFormat = 'dd.MM.yyyy HH:mm'; }

   if (!(date instanceof Date)) {
       date = new Date(date);
   }

   return format(date, dateFormat, { locale: it });
};

export const formatNumber = (value: number, decimals: number): string => {
    const formatter = new Intl.NumberFormat('it-CH', {
        style: 'decimal',
        minimumFractionDigits: decimals || 2,
    });
    return formatter.format(value || 0);
};

export const formatCurrency = (value: number, decimals: number): string => {

    const formatter = new Intl.NumberFormat('it-CH', {
        style: 'decimal',
        // currency: 'USD',
        minimumFractionDigits: decimals || 2,
    });
    return formatter.format(value || 0);
};

export const formatPercentage = (value: number, decimals: number): string => {
    return formatNumber(value, decimals) + '%';
};

export const formatBooleanShort = (value: boolean): string => {
   return value === true ? 'S' : 'N';
};

export const formatBooleanLong = (value: boolean): string => {
   return value === true ? 'Sì' : 'No';
};

export const authorizedMenus = (profile: UserProfile, menu: Menu[]): Menu[] => {
    if (profile && profile.sub) {
        const roles = profile.role;
        return menu.filter((m) => {
            return !m.autorizations || m.autorizations.some((role) => roles.includes(role));
        });
    } else {
        return menu.filter((m) => {
            return !m.autorizations;
        });
    }
};

export const jsonPretty = (value: any): string => {
    if (!value) return '';
    return JSON.stringify(JSON.parse(value), undefined, 3);
};
